import { Strings } from "src/resources";

export const PERMISSION = {
  itinerary: "ITINERARY",
  event: "EVENT",
  hotel: "HOTEL",
  supplier: "SUPPLIER",
  services: "SERVICES",
  region: "REGION",
  agent: "AGENT",
  agency: "AGENCY",
  termsCondition: "TERMS_CONDITION",
  subAdmin: "SUB_ADMIN"
};

export const PERMISSION_VALUE = {
  read: "R",
  create: "C",
  update: "U",
  delete: "D",
  activeInactive: "A"
};

export const SUB_ADMIN_LABELS = [
  {
    name: Strings.sub_admin_module_name,
    sort: false,
    sortName: "",
    sortOrder: false
  },
  {
    name: Strings.view,
    sort: false,
    sortName: "",
    sortOrder: false,
    checkbox: true,
    checkboxClass: "me-2",
    checked: false,
    action: PERMISSION_VALUE.read
  },
  {
    name: Strings.add_check,
    sort: false,
    sortName: "",
    sortOrder: false,
    checkbox: true,
    checkboxClass: "me-2",
    checked: false,
    action: PERMISSION_VALUE.create
  },
  {
    name: Strings.edit,
    sort: false,
    sortName: "",
    sortOrder: false,
    checkbox: true,
    checkboxClass: "me-2",
    checked: false,
    action: PERMISSION_VALUE.update
  },
  {
    name: Strings.delete,
    sort: false,
    sortName: "",
    sortOrder: false,
    checkbox: true,
    checkboxClass: "me-2",
    checked: false,
    action: PERMISSION_VALUE.delete
  },
  {
    name: Strings.A_I,
    sort: false,
    sortName: "",
    sortOrder: false,
    checkbox: true,
    checkboxClass: "me-2",
    checked: false,
    action: PERMISSION_VALUE.activeInactive
  }
];

export const ROLE_PERMISSION_INITIAL_VALUE = [
  {
    id: "01",
    name: Strings.itinerary_management,
    permissions: [],
    payload: PERMISSION.itinerary
  },
  {
    id: "02",
    name: Strings.event_management,
    permissions: [],
    payload: PERMISSION.event
  },
  {
    id: "03",
    name: Strings.supplier_management,
    permissions: [],
    payload: PERMISSION.supplier
  },
  {
    id: "04",
    name: Strings.service_management,
    permissions: [],
    payload: PERMISSION.services
  },
  {
    id: "05",
    name: Strings.region_management,
    permissions: [],
    payload: PERMISSION.region
  },
  {
    id: "06",
    name: Strings.agent_management,
    permissions: [],
    payload: PERMISSION.agent
  },
  {
    id: "07",
    name: Strings.agency_management,
    permissions: [],
    payload: PERMISSION.agency
  },
  {
    id: "08",
    name: Strings.sub_admin_title,
    permissions: [],
    payload: PERMISSION.subAdmin
  },
  {
    id: "09",
    name: Strings.terms_conditions_management,
    permissions: [],
    payload: PERMISSION.termsCondition
  },
  {
    id: "10",
    name: Strings.hotel_management,
    permissions: [],
    payload: PERMISSION.hotel
  }
];
